import React from "react";
import { Button } from "antd";
import { buildProspectEmbedSnippet } from "./prospectService";
import { apiRequest } from "util/services";
import styles from "./style.module.scss";

export default function ClaimedReady({ brandName, bot, onInstallWidget, onInstagram, onWhatsapp }) {
  const snippet = bot ? buildProspectEmbedSnippet(bot) : "";
  const copy = async () => {
    if (!snippet) return;
    try {
      await navigator.clipboard.writeText(snippet);
    } catch (_) {
      return;
    }
    apiRequest(
      "subscriptions/sonic-prospect/self-serve/milestone",
      "POST",
      { kind: "widget_installed" },
      true
    );
    if (onInstallWidget) onInstallWidget();
  };
  const connect = (kind, fn) => {
    apiRequest(
      "subscriptions/sonic-prospect/self-serve/milestone",
      "POST",
      { kind: "channel_connected" },
      true
    );
    if (fn) fn();
  };

  return (
    <div className={styles.productHome}>
      <h1 className={styles.onboardHeadline}>Your {brandName} assistant is ready</h1>
      <p className={styles.productLede}>5 free qualified leads included</p>
      <div className={styles.readyPreview} aria-hidden="true">
        <p>Hi, I can answer questions about {brandName}.</p>
        <p>Ask about shipping, appointments, or a quote.</p>
      </div>
      <ol className={styles.readySteps}>
        <li>
          <strong>Install the website widget</strong>
          <pre className={styles.snippetBox}>{snippet || "The snippet appears with your assistant."}</pre>
          <Button type="primary" onClick={copy} disabled={!snippet}>
            Copy snippet
          </Button>
        </li>
        <li>
          <strong>Connect Instagram</strong>
          <Button onClick={() => connect("instagram", onInstagram)}>Connect Instagram</Button>
        </li>
        <li>
          <strong>Connect WhatsApp</strong>
          <Button onClick={() => connect("whatsapp", onWhatsapp)}>Connect WhatsApp</Button>
        </li>
      </ol>
    </div>
  );
}
